import {
  COLOR_DETAIL,
  ICON_DETAIL,
} from '@/services/graphql/fragments';

/*********************************************
 * Collections
 ********************************************/

const COLLECTION_ID_NO_BRACKETS = `
  id
`;

const COLLECTION_LISTING_MEMBER_SUMMARY = `
  {
    members {
      name
      email
      id
      picture
    }
    count
  }
`;

const COLLECTION_LISTING_FILE_STRUCTURE = `
  filename
  size
  id
  type
  url
  key
`;

const COLLECTION_LISTING_USER_INFO = `
  {
    name
    email
    id
    picture
  }
`;

const COLLECTION_LISTING = `
  {
    createdDate
    createdProUser
    creator ${COLLECTION_LISTING_USER_INFO}
    follow
    id
    isVerified
    lastModified
    libraryId
    logo
    memberSummary ${COLLECTION_LISTING_MEMBER_SUMMARY}
    name
    productsCount
    publish
    publishExpirationDate
    publishExpirationMessage
    suggested
    type
    verifiedPageId
    verifiedPageName
    workspaceId
    pictures {
      attachment {
        ${COLLECTION_LISTING_FILE_STRUCTURE}
      }
    }
  }
`;

const WORKSPACE_ID_AND_NAME = `
  data {
    id
    name
  }
  nextToken
`;

/*********************************************
 * Projects
 ********************************************/

const PROJECT_LISTING_USER_INFO = `
  {
    name
    email
    id
    picture
    projectTeamRole
  }
`;

const PROJECT_LISTING_MEMBER_SUMMARY = `{
  users {
    name
    email
    id
    picture
  }
  count
}`;

const PROJECT_LISTING_PROJECT = `
  type
  status
  projectName
  projectId
  createdDate
  projectLastModified
  creator: projectCreator ${PROJECT_LISTING_USER_INFO}
  isShared
  tags
  phase
  number
  commentsUnread
  sourceLibraryId
  memberSummary ${PROJECT_LISTING_MEMBER_SUMMARY}
  projectColor ${COLOR_DETAIL}
  projectIcon ${ICON_DETAIL}
  hideResolvedComments
`;

const PROJECT_LISTING = `
  projects {
    ${PROJECT_LISTING_PROJECT}
  }
  nextToken
`;

const PROJECT_IMPORT_DOCUMENT = `
  id
  workspaceId
  projectId
  status
  processedCount
  startedAt
  endedAt
  errors
`;

export {
  COLLECTION_ID_NO_BRACKETS,
  COLLECTION_LISTING,
  COLLECTION_LISTING_MEMBER_SUMMARY,
  COLLECTION_LISTING_FILE_STRUCTURE,
  COLLECTION_LISTING_USER_INFO,
  WORKSPACE_ID_AND_NAME,
  PROJECT_LISTING,
  PROJECT_IMPORT_DOCUMENT,
};
